(function () {
  'use strict';

  angular.module('app').component('bookingHeader', bookingHeader());

  function bookingHeader() {
    return {
      bindings: {
        booking: '<',
      },
      controller: BookingHeaderComponent,
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/components/booking-header/booking-header.component.html',
    };
  }

  BookingHeaderComponent.$inject = ['BookingService', 'BookingItemService'];

  function BookingHeaderComponent(BookingService, BookingItemService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.statusConfirmed = 'confirmed';

    // public methods
    // -----------------------
    vm.openSendBookingConfirmationToClient = function () {
      if (vm.booking.status !== vm.statusConfirmed) {
        return;
      }

      BookingService.openSendBookingConfirmationToClient(vm.booking); // , {}
    };

    vm.downloadBookingVouchers = function () {
      if (vm.booking.status !== vm.statusConfirmed) {
        //  || vm.allBookingItemsNotConfirmed
        return;
      }

      vm.booking.booking_items.forEach(function (booking_item) {
        downloadBookingItemVoucher(booking_item);
      });
    };

    vm.openSendBookingItineraryToClient = function () {
      if (vm.booking.status !== vm.statusConfirmed) {
        return;
      }

      BookingService.openSendBookingItineraryToClient(vm.booking); // , {}
    };

    vm.openSendBookingVouchersToClient = function () {
      if (vm.booking.status !== vm.statusConfirmed) {
        return;
      }

      BookingService.openSendBookingVouchersToClient(vm.booking); // , {}
    };

    vm.sendInvoiceToClient = function () {
      if (vm.booking.status !== vm.statusConfirmed || !vm.booking.invoice) return;

      return;
    };

    function downloadBookingItemVoucher(booking_item) {
      const params = {
        company_id: vm.booking.company_id,
        skip_check_role: true,
      };

      BookingItemService.downloadBookingItemVoucher(booking_item, params);
    }
  }
})();
